const {GUIDE_SCENARIOS, MODULES, REFERENCE_SCENARIOS, WORKFLOWS} = require('./catalog.data.cjs')
const {filterAccessibleScenarios: filterByAccess} = require('./runtimeCore.cjs')

/** 每个已开放路由只有一个首次自动出现的主场景。 */
export function findPrimaryScenarioByRouteName(routeName) {
  return GUIDE_SCENARIOS.find((item) => item.routeName === routeName && item.primary !== false) || null
}

/** 同一页面可按不同业务意图提供多个可手动重看的精确场景。 */
export function findScenariosByRouteName(routeName) {
  return GUIDE_SCENARIOS.filter((item) => item.routeName === routeName)
}

export function findScenarioByKey(key) {
  return GUIDE_SCENARIOS.concat(REFERENCE_SCENARIOS).find((item) => item.key === key) || null
}

/** 只返回账号能访问的页面场景；详情页由当前路由授权结果兜底。 */
export function filterAccessibleScenarios(scenarios, accessiblePaths, currentRouteName) {
  return filterByAccess(scenarios, accessiblePaths, currentRouteName)
}

export {GUIDE_SCENARIOS, MODULES, REFERENCE_SCENARIOS, WORKFLOWS}
